// src/components/FloatingCall.js
import React from 'react';
import { Phone } from 'lucide-react';
import { COMPANY_INFO } from '../data';
import './FloatingCall.css';

export default function FloatingCall() {
  return (
    <a
      href={`tel:${COMPANY_INFO.phone}`}
      className="floating-call"
      aria-label={`Call ${COMPANY_INFO.phone}`}
    >
      <Phone size={22} />
      <span className="floating-call-pulse" />
    </a>
  );
}